// versionCheck.js
import packageJson from '../../package.json';

export const checkAppVersion = () => {
 
  const currentVersion = packageJson.version;
  const cachedVersion = localStorage.getItem('appVersion') || '0.1.17';
 console.log(currentVersion > cachedVersion,currentVersion , cachedVersion);
 
  if (currentVersion > cachedVersion) {
    console.log(`New version detected: ${currentVersion}. Clearing cache...`);
    clearCacheAndReload(currentVersion);
  } else {
    console.log(`App is up to date: ${currentVersion}`);
  }
};

const clearCacheAndReload = (version) => {
  if ('caches' in window) {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  }
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });
  }

  localStorage.clear();
  localStorage.setItem('appVersion', version);
  window.location.reload(true);
  console.log('Cache cleared.');
  document.getElementById("logout")?.click();
};
